import {
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
    InputType,
} from '@fitogest/reactive-form-builder/interfaces';
import { PedidoModel } from 'src/app/models/visitas/pedido.model';


export class VisitasPedidosListModalFormDefinition {
  public readonly formFields: Form<PedidoModel>;
  public readonly model: Partial<PedidoModel>;

  constructor(type: FormType, model: Partial<PedidoModel>, private readonly context: any = {}) {
    this.model = model;
    this.formFields = {
      name: 'visitas-pedidos-list-modal',
      header: 'Datos del pedido',
      type,
      sections: this.getSections(),
      table: null,
      uploadButton: { isEnabled: false, label: '' },
      signed: false,
    };
  }

  private getSections(): FormSection<PedidoModel>[] {
    const showLote = this.context.currentUser?.tipo !== 'comunero';
    const fields: FormField<PedidoModel>[] = [
      this.textField('finca', 'Finca', 1, true, 4),
      this.textField('albaran', 'Albarán', 2, true, 4),
      this.textField('fecha_pedido', 'Fecha Pedido', 3, true, 4),
      this.textField('fecha_entrega', 'Fecha Entrega', 4, true, 4),
    ];

    for (let index = 1; index <= 5; index++) {
      const suffix = index === 1 ? '' : ` ${index}`;
      fields.push(this.textField(`producto_nombre${index}`, `Producto${suffix}`, fields.length + 1, true, 4));
      fields.push(this.textField(`cantidad${index}`, `Cantidad${suffix}`, fields.length + 1, true, 4));
      fields.push(this.textField(`lote${index}`, `Lote${suffix}`, fields.length + 1, showLote, 4));
    }

    fields.push(this.textField('estado', 'Estado', fields.length + 1, showLote, 4));

    return [{ name: '', fields, width: 12, isVisible: true, order: 1 }];
  }

  private textField(name: string, label: string, order: number, isVisible = true, width = 4, inputType: InputType = InputType.TEXT): FormField<PedidoModel> {
    return {
      name,
      label,
      input: {
        type: inputType,
        isEditable: true,
        ...(inputType === InputType.TEXTAREA ? { textAreaConfiguration: { hasVoiceTranscription: false, canTakePhoto: false, photoField: undefined } } : {}),
      },
      width,
      conditions: this.conditions({ isVisible }),
      order,
    };
  }


  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }

}
